export default "__VITE_ASSET__c70625f1__"